import { Box } from "@mui/system";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFollowUpList } from "../../../api/sales";
import ControlledTable from "../../../component/ControlledTable";
import { handleAxiosError } from "../../../config/action-config";
import { followUpListTable as tableDef } from "../../../config/grid-columns-defs";

export default function ViewSalesFollowup({ leadId }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const getRows = async (numRows, startRow) => {
    return getFollowUpList(
      { lead_id: leadId, limit: numRows, offset: startRow },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.records;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTable = async () => {
    try {
      const { data } = await getFollowUpList(
        { limit: 10, offset: 0 },
        user.token
      );
      setTotalCount(parseInt(data.total) === 0 ? -1 : parseInt(data.total));
      setRows(data.records);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };

  return (
    <div>
      <Box sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}></Box>
      <div className="ag-theme-material" style={{ height: "300px" }}>
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          hasActionButtons={false}
        />
      </div>
    </div>
  );
}
